import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class SolutionsService {
  constructor(private http: HttpClient) {
  }

    supportPhone="5541984350292";
    comercialPhone="5541984350292";

    marcaDoa = {
        "name": "Marca Doa",
        "color": "#F0B213",
        "tooltip": "Ações em que a doação será realizada financeiramente pela sua marca."
    }

    eCommerce = {
        "name": "E-Commerce",
        "color": "#9653A1",
        "tooltip": "Experiências que serão instaladas em sua loja online."
    }

    clienteDoa = {
        "name": "Consumidor Doa",
        "color": "#13C16E",
        "tooltip": "Ações em que a doação será realizada financeiramente pelo seu cliente"
    }

    lojaFisica = {
        "name": "Loja Física",
        "color": "#EE1D1D",
        "tooltip": "Experiências criadas para usar em sua loja física"
    }
   
   solutions: any[] = [
        {
            "id": "cashback-solidario",
            "logo": "../../../assets/img/solutions/logo-1compra-1doacao-negativa.png",
            "hasLogo": true,
            "title": "Cashback Solidário",
            "description": "Doe a cada compra realizada em seu e-commerce, conquiste seu cliente, gerando aumento de conversão e fidelização.",
            "subtitle": "1 Compra = 1 Doação (Cashback Solidário)",
            "keyWords": ["marca-doa", "e-commerce", "doe-vendas", "conversao-fidelizacao", "branding", "investimento-esg" ],
            "priority": 1,
            "emphasis": true,
            "filterOn": true,
            "characteristics": {
                "color": "#621178"
            },
            "tags":[this.marcaDoa, this.eCommerce],
            "callToAction": {                
                "buttonText": "Instalar",
                "buttonActived": "Acessar",
                "disabled": false,
                "disableInfo": "Produto não acessivel",
                "link": "/#/cashback",
                "media":"https://www.youtube.com/embed/ap00_MOuMHk",
                "mediaType": "video",
                "title": "Entenda o Cashback Solidário (1 Compra = 1 Doação)",
                "description": "Doe a cada compra realizada em seu e-commerce, conquiste seu cliente, gerando aumento de conversão e fidelização.",
                "popUpButton": "Instalar solução",
                "hasLP": false,
                "landingPage":{}
            }
        },
        {
            "id": "tela-arrecadacao",
            "logo": "",
            "hasLogo": false,
            "title": "Tela de arrecadação",
            "description": "Crie em poucos cliques uma campanha de arrecadação para instituições que deseja se engajar.",
            "subtitle": "Tela de arrecadação",
            "keyWords": ["cliente-doa", "e-commerce", "marca-doa", "doe-vendas", "loja-fisica", "engajamento", "branding", "investimento-esg", "gestao-doacao" ],
            "characteristics": {
                "color": "#7695CD"
            },
            "tags":[this.eCommerce, this.marcaDoa, this.clienteDoa, this.lojaFisica],        
            "callToAction": {                
                    "buttonText": "Criar",
                    "buttonActived": "Criado",
                    "disabled": true,
                    "disableInfo": "Produto não disponível",
                    "link": "/#/campaign/list?show=direct",
                    "media":"../../../assets/img/solutions/banner-campanhas.png",
                    "mediaType": "image",
                    "title": "as Tela de arrecadação",
                    "description": "Em poucos cliques, crie uma campanha de arrecadação para a organização que preferir e torne a sua empresa um vetor de transformação.",
                    "popUpButton": "Instalar Solução",
                    "hasLP": false,
                    "landingPage":{}
                }
            ,
            "priority": 99,
            "emphasis": false,
            "filterOn": false
        },
        {
            "id": "dobra-doacao",
            "logo": "",
            "hasLogo": false,
            "title": "Dobra Doação",
            "description": "Escolha uma ONG para sua marca colaborar com a porcentagem desejada em cada doação realizada no site da organização.",
            "subtitle": "Dobra doação (Matchfunding)",
            "keyWords": ["cliente-doa", "marca-doa", "doe-vendas", "e-commerce", "loja-fisica", "engajamento", "branding", "investimento-esg" ],
            "characteristics": {
                "color": "#7695CD"
            },
            "tags":[this.clienteDoa, this.eCommerce, this.marcaDoa, this.lojaFisica],        
            "callToAction": {                
                    "buttonText": "Criar",
                    "buttonActived": "Criado",
                    "disabled": true,
                    "disableInfo": "Produto não disponível",
                    "link": "/#/matchfunding?show=direct",
                    "media":"../../../assets/img/solutions/banner-dobra-doacao.png",
                    "mediaType": "image",
                    "title": "Entenda o Dobra Doação (MatchFunding)",
                    "description": "Em poucos cliques, crie uma campanha de arrecadação para a organização que preferir e torne a sua empresa um vetor de transformação.",
                    "popUpButton": "Instalar Solução",
                    "hasLP": false,
                    "landingPage":{}
                }
            ,
            "priority": 99,
            "emphasis": false,
            "filterOn": false
        },
        {
            "id": "cupom-solidario",
            "logo": "",
            "hasLogo": false,
            "title": "Cupom Solidário",
            "description": "Ofereça cupons de desconto com impacto social. Para desbloquear a oferta, seu cliente deve fazer uma doação.",
            "subtitle": "Cupom Solidário",
            "keyWords": ["cliente-doa", "e-commerce", "loja-fisica" , "engajamento", "branding", "conversao-fidelizacao" ],
            "characteristics": {
                "color": "#7695CD"
            },
            "tags":[ this.clienteDoa, this.eCommerce, this.lojaFisica ],        
            "callToAction": {                
                    "buttonText": "Criar",
                    "buttonActived": "Criado",
                    "disabled": true,
                    "disableInfo": "Produto não acessivel",
                    "link": "/#/campaign/list",
                    "media":"../../../assets/img/solutions/banner-cupom-solidario.png",
                    "mediaType": "image",
                    "title": "Entenda o Cupom Solidário",
                    "description": "Ofereça mais do que desconto e atraia clientes! Para desbloquear a oferta, seu cliente faz uma doação para uma causa social.",
                    "popUpButton": "Receber mais informações",
                    "hasLP": false,
                    "landingPage":{}
                }
            ,
            "priority": 99,
            "emphasis": false,
            "filterOn": false
        },
        {
            "id": "cadastre-doe",
            "logo": "",
            "hasLogo": false,
            "title": "Cadastre e Doe",
            "description": "Crie uma página de captura de leads, e gere uma doação a cada cadastro realizado nesta página.",
            "subtitle": "Cadastre e Doe",
            "keyWords": ["marca-doa", "doe-vendas", "e-commerce", "loja-fisica", "branding", "conversao-fidelizacao", "investimento-esg" ],
            "characteristics": {
                "color": "#A2263B"
            },
            "tags":[this.eCommerce, this.marcaDoa, this.lojaFisica],        
            "callToAction": {                
                    "buttonText": "Contratar",
                    "buttonActived": "Contratado",
                    "disabled": false,
                    "disableInfo": "Produto não disponível",
                    "link": "/#/profile/lp-solutions?id=cadastre-doe",
                    "media":"../../../assets/img/solutions/banner-cadastre-doe.png",
                    "mediaType": "image",
                    "title": "Entenda o Cadastre e Doe",
                    "description": "Em poucos cliques, crie uma campanha de arrecadação para a organização que preferir e torne a sua empresa um vetor de transformação.",
                    "popUpButton": "Receber mais informações",
                    "hasLP": true,
                    "landingPage":{
                        "id": "cadastre-doe",
                        "title": "Criação do Cadastre e Doe",
                        "description": "Capture leads de uma maneira diferente, com uma página personalizável com a cara da sua marca. Comunique sua transparência de forma automatizada e aumento o engajamento e fidelização dos seus clientes.",
                        "image": "../../../assets/img/lp-solutions/lp-cadastre-doe.png",
                        "border": "#A2263B",
                        "hubId": "7470bd6d-2d16-4c97-814a-3baff3b65510"
                    }
                }
            ,
            "priority": 5,
            "emphasis": false,
            "filterOn": true
        },
        {
            "id": "troco-solidario",
            "logo": "",
            "hasLogo": false,
            "title": "Troco solidário",
            "description": "Você tem problemas com falta de troco no caixa da sua loja? Com o Troco Solidário o consumidor doa o troco digital diretamente no PDV.",
            "subtitle": "Troco solidário",
            "keyWords": ["cliente-doa", "loja-fisica", "arredondamento-troco", "branding" ],
            "characteristics": {
                "color": "#14CFB0"
            },
            "tags":[  this.clienteDoa, this.lojaFisica],        
            "callToAction": {                
                "buttonText": "Contratar",
                "buttonActived": "Contratado",
                "disabled": false,
                "disableInfo": "Produto não acessivel",
                "link": "/#/profile/lp-solutions?id=troco-solidario",
                "media":"../../../assets/img/solutions/banner-troco-solidario.png",
                "mediaType": "image",
                "title": "Entenda o Troco Solidário",
                "description":  "Dê a opção do consumidor doar o troco digital diretamente no PDV, eliminando custos tributários em um processo transparente e acessível, pois cada doação tem como origem o CPF do consumidor.",
                "popUpButton": "Receber mais informações",
                "hasLP": true,
                "landingPage":{
                    "id": "troco-solidario",
                    "title": "Implementação do Troco Solidário",
                    "description": "Com o Troco Solidário, o consumidor doa o troco digital diretamente no PDV, eliminando custos tributários em um processo transparente e acessível, pois cada doação tem como origem o CPF do consumidor.",
                    "image": "../../../assets/img/lp-solutions/lp-troco-solidario.png",
                    "image2": "../../../assets/img/lp-solutions/carrefour-image.png",
                    "border": "#5ECBB2",
                    "hubId": "f3be7188-5da8-4ff7-82c9-0a01792ddbad"
                }
            }
            ,
            "priority": 6,
            "emphasis": false,
            "filterOn": true
        },
        {
            "id": "do-seu-jeito",
            "logo": "",
            "hasLogo": false,
            "title": "Do seu jeito",
            "description": "Acesse nossa documentação, utilize nossa API e coloque impacto social em seu app/loja/empresa como preferir.",
            "subtitle": "Do seu jeito (API)",
            "keyWords": ["marca-doa", "doe-vendas", "e-commerce", "conversão", "loja-fisica", "branding", "investimento-esg", "gestao-doacao" ],
            "characteristics": {
                "color": "#FE6900"
            },
            "tags":[this.eCommerce, this.marcaDoa, this.clienteDoa, this.lojaFisica],        
            "callToAction": {                
                    "buttonText": "Acessar",
                    "buttonActived": "Conte sua ideia",
                    "disabled": false,
                    "disableInfo": "Produto não acessivel",
                    "link": "/#/profile/lp-solutions?id=do-seu-jeito",
                    "media":"../../../assets/img/solutions/banner-do-seu-jeito.png",
                    "mediaType": "image",
                    "title": "Entenda o Do Seu Jeito",
                    "description": "De a oportunidade do consumidor doar o troco da compra realizada em seu e-commerce gerando impacto social, sem abrir mão da sua margem.",
                    "popUpButton": "Conte a sua ideia",
                    "hasLP": true,
                    "landingPage":{
                        "id": "do-seu-jeito",
                        "title": "Conte-nos sobre como pensou “Do Seu Jeito”?",
                        "description": "Conectamos nossa tecnologia ao seu sistema de forma personalizada, criando a mecânica necessária para a sua iniciativa acontecer, descomplicando a parte fiscal, financeira e os processos da doação, e automatizando a transparência da sua ação.",
                        "image": "../../../assets/img/lp-solutions/lp-do-seu-jeito.png",
                        "border": "#A2263B",
                        "hubId": "cb3dd405-6b9b-4da1-9a7f-a4aea3da4c1c"
                    }
                }
            ,
            "priority": 99,
            "emphasis": false,
            "filterOn": true
        },
        {
            "id": "bom-troco",
            "logo": "../../../assets/img/solutions/logo-bomtroco-negativa.png",
            "hasLogo": true,
            "title": "Bom Troco",
            "description": "Dê a oportunidade para o seu cliente gerar impacto social, sem comprometer sua margem de lucro.",
            "subtitle": "Bom Troco (Arredondamento de troco)",
            "keyWords": ["cliente-doa", "e-commerce", "arredondamento-troco", "conversão", "branding" ],
            "characteristics": {
                "color": "#50BB6B"
            },
            "tags":[this.clienteDoa, this.eCommerce],
            "callToAction": 
                {                
                    "buttonText": "Saiba mais",
                    "buttonActived": "Saiba mais",
                    "disabled": false,
                    "disableInfo": "Produto não acessivel",
                    "link": "/#/profile/lp-solutions?id=bom-troco",
                    "media": "../../../assets/img/solutions/banner-bom-troco.png",
                    "mediaType": "image",
                    "title": "Entenda o Bom Troco",
                    "description": "Ofereça a oportunidade de fazer o bem a cada compra realizada em seu e-commerce! Ao adicionar o BomTroco à sua loja, você dá liberdade para seu cliente decidir doar o troco para um projeto de impacto social.",
                    "popUpButton": "Receber mais informações",
                    "hasLP": true,
                    "landingPage":{
                        "id": "bom-troco",
                        "title": "Implementação do BomTroco",
                        "description": "Ofereça a oportunidade de fazer o bem a cada compra realizada em seu e-commerce! Ao adicionar o BomTroco à sua loja, você dá liberdade para seu cliente decidir doar o troco para um projeto de impacto social.",
                        "image": "../../../assets/img/lp-solutions/lp-bom-troco.png",
                        "border": "#51BB6C",
                        "hubId": "cf347f86-12a6-47ed-ac02-224ebbd62d42"
                    }
                }
            ,
            "priority": 99,
            "emphasis": false,
            "filterOn": true
        }
    ]
}
